import { render, staticRenderFns } from "./_blogSimple.vue?vue&type=template&id=137cd541&"
import script from "./_blogSimple.vue?vue&type=script&lang=js&"
export * from "./_blogSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports